import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({ standalone: false,
  selector: 'vfa-cp-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss'],
})
export class GenericErrorComponent implements OnInit {
  constructor(public authService: AuthService) {}

  ngOnInit(): void {}
}

